export function findImbeddedKeyValue(
    data: Record<string, unknown>,
    key: string
) {
    for (const [objKey, objValue] of Object.entries(data)) {
        if (objKey === key) {
            return objValue;
        }
        if (objValue && typeof objValue === `object`) {
            const result = findImbeddedKeyValue(
                objValue as Record<string, unknown>,
                key
            );
            if (result) {
                return result;
            }
        }
    }
    return null;
}
